import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RefreshProvider } from '@app/providers';
import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';
import { LanguageService } from '@app/services/language.service';
import { AppUpdateService } from '@app/services/app-update.service';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    title = 'ivstore-mobile';

    constructor(
        private titleService: Title,
        private translate: TranslateService,
        private refreshProvider: RefreshProvider,
        private languageService: LanguageService,
        private appUpdateService: AppUpdateService
    ) {
        this.initLanguage();
    }

    ngOnInit(): void {
        this.titleService.setTitle(environment.appName);

        this.appUpdateService.init();

        this.setSizeAndIgnoreResize();

        // this.initPullToRefresh();
    }

    // 🌍 INIT LANGUAGE
    private initLanguage(): void {
        this.languageService.init();
    }

    // 🔄 PULL TO REFRESH
    private initPullToRefresh(): void {
        this.translate
            .get([
                'pullToRefresh.instructionsRefreshing',
                'pullToRefresh.instructionsPullToRefresh',
                'pullToRefresh.instructionsReleaseToRefresh',
            ])
            .subscribe((translation: any) => {
                this.refreshProvider.init(translation);
            });
    }

    // 📱 VIEWPORT FIX MOBILE
    private setSizeAndIgnoreResize(): void {
        const attribute = `height=${window.innerHeight}px,width=${window.innerWidth}px,initial-scale=1.0`;
        const meta = document.querySelector('meta[name=viewport]');

        if (meta) {
            (meta as HTMLMetaElement).setAttribute('content', attribute);
        }
    }
}
